"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageViewPort = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../../helpers");
exports.StyledPageViewPort = styled_components_1.default.div `
    position: fixed;
    display: flex;
    z-index: ${helpers_1.POPOVER_Z_INDEX};
    flex-direction: row;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding-top: ${({ isFullPage }) => (isFullPage ? 0 : helpers_1.SIZE_XXL)};
    background: ${({ isFullPage, color }) => color ? color : isFullPage ? '#fff' : `rgba(0,0,0, .2)`};
    justify-content: stretch;
    flex-shrink: 0;
    * > {
        flex-grow: 1;
    }
`;
//# sourceMappingURL=PageViewport.styles.js.map